export enum MediaCategory {
  MARKETING = 'marketing',
  TUTORIAL = 'tutorial',
  DOCUMENT = 'docs'
}
